import { useQuery } from '@tanstack/react-query';
import { apiClient } from './api-client';
import { AssetResponse } from '@plerionhq/types-asset';

export const decodePrn = (encodedPrn: string) =>
  decodeURIComponent(atob(encodedPrn));

export const encodePrn = (prn: string) => btoa(encodeURIComponent(prn));

export type GetAssetResponse = { asset: AssetResponse };

export const useGetAssetWithEncodedPrn = (encodedPrn: string | undefined) =>
  useQuery({
    queryKey: ['asset', encodedPrn ? decodePrn(encodedPrn) : null],
    queryFn: async () => {
      if (!encodedPrn) {
        return null;
      }
      const response = await apiClient.get<GetAssetResponse>(
        `/api/inventory/asset/${encodedPrn}`,
      );
      return response.data;
    },
    enabled: !!encodedPrn,
  });

export const useGetAsset = (assetId: string | undefined) =>
  useQuery({
    queryKey: ['asset', assetId],
    queryFn: async () => {
      if (!assetId) {
        return null;
      }
      const response = await apiClient.get<GetAssetResponse>(
        `/api/inventory/asset/${encodePrn(assetId)}`,
      );
      return response.data;
    },
    enabled: !!assetId,
  });
